// src/pages/ErrorPage.tsx
import React from 'react';
import { Alert, AlertHeading, CenteredPage, Divider, Text } from '../components/ui';

interface ErrorPageProps {
  message: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ message }) => {
  return (
    <CenteredPage fixed light>
      <Alert variant="danger" textAlign="center" shadow="lg" style={{ maxWidth: '80%', padding: '2rem' }}>
        <AlertHeading displaySize={4}>Oops! Une erreur est survenue.</AlertHeading>
        <Text variant="lead">{message}</Text>
        <Divider />
        <Text marginBottom={0}>Nous sommes désolés pour le désagrément.</Text>
      </Alert>
    </CenteredPage>
  );
};

export default ErrorPage;
